import YellowTriangularThumbnailPath from '../../../assets/template-thumbnails/triangular/yellow-triangular-template-thumbnail.png';

const YellowTriangularTemplate = {
    id: 'yellow-triangular-template',
    name: 'Yellow',
    category: 'Triangular',
    settings: {
      layoutId: 'centered-header',
      designId: 'vibrant-yellow',
      style: 'tech',
      background: 'triangle',
      barStyleId: 'squares',
      specialEffectId: 'timeline',
      typography: {
        cvTitle: { fontSize: 40, lineHeight: 1, fontFamily: "'Roboto', sans-serif" },
        sectionTitle: { fontSize: 11, lineHeight: 1.3, fontFamily: "'Roboto', sans-serif" },
        body: { fontSize: 9.5, lineHeight: 1, fontFamily: "'Roboto', sans-serif" },
        smallText: { fontSize: 8, lineHeight: 1.5, fontFamily: "'Roboto', sans-serif" },
      },
    },
    thumbnail: YellowTriangularThumbnailPath
  };

export default YellowTriangularTemplate; 